export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/identity.js
// module id = 282
// module chunks = 0